import { t } from 'i18next'
import { TipoPersonaMaster } from 'src/enums/EscritosLegales'
import { TipoPersona } from 'src/interfaces/Catalog'

export function checkTipoPersonaFisica(tipoPersona: TipoPersona): boolean {
  const tipo: string[] = [TipoPersonaMaster.JURIDICA, TipoPersonaMaster.SIN_ENTIDAD]
  return tipo.includes(tipoPersona?.codigo)
}

export const getLabelByTipoPersona = (tipoPersona: TipoPersona): string => {
  if (tipoPersona?.codigo === TipoPersonaMaster.JURIDICA) {
    return t('form.field.razon_social')
  }
  if (tipoPersona?.codigo === TipoPersonaMaster.SIN_ENTIDAD) {
    return t('form.field.entidad_legal')
  }
  return t('form.field.nombre')
}

export const personaFisica: TipoPersona = { id: 1, codigo: '002', descripcion: 'PERSONA FÍSICA' }
